import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
import { isEmptyValue } from '../../core/helpers/value-empty-checker.helper';

@Pipe({
  name: 'orderBy',
})
export class OrderByPipe implements PipeTransform {
  transform(value: any[], column: any[] | string, order: any): any[] {
    if (!value || order === '' || !order) {
      return value;
    } // no array
    if (value.length <= 1) {
      return value;
    } // array with only one item
    if (Array.isArray(column)) {
      const [first, second] = column;
      const partition = _.partition(value, columns => {
        return !isEmptyValue(columns[first]) || !isEmptyValue(columns[second]);
      });
      return _.concat(
        _.orderBy(
          partition[0],
          column.map(col => {
            return row => {
              const value = _.get(row, col);
              return value != null ? (typeof value == 'string' ? this.displayString(col, value) : value) : '';
            };
          }),
          [order, order]
        ),
        partition[1]
      );
    } else {
      const partition = _.partition(value, (val: any) => {
        return val[column] != null && val[column] !== '';
      });

      if (typeof value[0][column] == 'boolean') {
        const partition2 = _.partition(value, (val: any) => {
          return val[column];
        });
        if (order == 'asc') return _.concat(partition2[1], partition2[0]);
        else return _.concat(partition2[0], partition2[1]);
      } else {
        return _.concat(
          _.orderBy(
            partition[0],
            [
              val =>
                val[column] != null
                  ? typeof val[column] == 'string'
                    ? column == 'Job' || column == 'Job_Name' || column == 'WorkOrder' || column == 'RQID' || column == 'ReturnedToJob'
                      ? parseInt(_.trimStart(val[column]))
                      : column == 'OverallScore' || column == 'ActualUnits'
                        ? parseFloat(_.trimStart(val[column]))
                        : _.trimStart(val[column].toLowerCase())
                    : val[column]
                  : '',
            ],
            order
          ),
          partition[1]
        );
      }
    }
  }

  private displayString(col: string, value: string) {
    if (col == 'Job' || col == 'WorkOrder') {
      return parseInt(_.trimStart(value));
    }

    if (!isNaN(Number(value))) {
      const parsed = parseFloat(_.trimStart(value));
      if (parsed && parsed != 0) {
        return parsed;
      }
    }

    return _.trimStart(value.toLowerCase());
  }
}
